export default __webpack_public_path__ + "static/media/Sub-Zero@3x.3ebc7a78.png";